module.exports = "<h2>Object vs. Any</h2><h4 class=\"fragment\">Java's 'Object' type is called 'Any' in Kotlin</h4><pre class=\"fragment\"><code class=\"lang-kotlin\">val unknownNonNull: Any = ...\nval unknownNullable: Any? = ...</code></pre><h4 class=\"fragment\">'Object' is a special construct in Kotlin</h4><pre class=\"fragment\"><code class=\"lang-kotlin\">object { .. }  // Singleton\ncompanion object { .. }  // Static singleton</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-syntax/06.pug
// module id = 328
// module chunks = 1